import { useContext, useEffect, useState } from 'react';
import { Filters } from './Filters';
import { TableComponent } from '../../../../components/Table';
import useApi from '../../../../services/request.service';
import { Column } from 'primereact/column';
import { StoreContext } from '../../../../context/Provider';

export const TableHistorySam = () => {
  const [filterSamId, setFilterSamId] = useState<string>('');
  const [sort, setSort] = useState([{ field: '', order: -1 }]);
  const [loader, setLoader] = useState<boolean>(false);
  const { genericApiCallApiBilling } = useApi();
  const [histories, setHistories] = useState([]);
  const [temporalHistories, setTemporalHistories] = useState<any[]>([]);
  const context = useContext(StoreContext);
  const { dispatchLoading } = context;

  useEffect(() => {
    if (filterSamId === '') {
      setTemporalHistories(histories);
    } else {
      let filteredData = histories;
      filteredData = filteredData.filter((data: any) =>
        data?.Sam?.includes(filterSamId)
      );
      setTemporalHistories(filteredData);
    }
  }, [filterSamId]);

  useEffect(() => {
    setTemporalHistories(histories);
  }, [histories]);

  let defaultColumns = [
    {
      field: 'Sam',
      header: 'SAM ID',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'StatusSam',
      header: 'Estatus',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'DeviceType',
      header: 'Dispositivos',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'Operator',
      header: 'Operadores tecnológicos',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'KeyVersion',
      header: 'Ver. llave',
      sortable: true,
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'Eur',
      header: 'EUR',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'Project',
      header: 'Proyectos',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'Description',
      header: 'Descripción',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'User',
      header: 'Usuario',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'Date',
      header: 'Fecha',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
  ];

  const getColumnsToDisplayIntable = () => {
    let columns = defaultColumns.map((column: any, index: any) => {
      const key = index.toString();
      return (
        <Column
          key={key}
          field={column.field}
          filterField={column.field}
          dataType={column.isFilter ? column.dataType : undefined}
          header={column.header}
          bodyClassName={'!text-grey !text-sm'}
          style={{
            flexGrow: 1,
            flexBasis: '100px',
          }}
          headerClassName={'!text-black !justify-between !bg-white'}
          sortable={column.sortable}
          filterMenuStyle={{ width: '14rem' }}
          filter={false}
          body={column.body}
        />
      );
    });

    return columns;
  };
  return (
    <div className="flex w-full h-full relative flex-col gap-y-2">
      <div className="flex w-full h-24">
        <Filters
          setFilterSamId={setFilterSamId}
          setLoader={setLoader}
          dispatchLoading={dispatchLoading}
          genericApiCallApiBilling={genericApiCallApiBilling}
          setHistories={setHistories}
        />
      </div>

      <div className="h-full flex flex-col w-full overflow-y-auto relative bg-white rounded-md shadow-lg p-2  ">
        <TableComponent
          value={temporalHistories}
          sortField="name"
          responsiveLayout="scroll"
          globalFilterFields={[]}
          resizableColumns
          className="flex h-full w-full relative rounded"
          paginator
          setSort={setSort}
          sort={sort}
          reorderableColumns={true}
          OnEmptyMessage="No se encontraron registros disponibles."
          loading={loader}>
          {getColumnsToDisplayIntable()}
        </TableComponent>
      </div>
    </div>
  );
};
